// import React, { useEffect } from "react";
// import Sidebar from "./Sidebar.js";
// import "./dashboard.css";
// import Typography from '@mui/material/Typography';
// import { Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// // import { getAdminProduct } from "../../app/slices/products.js";
// // import { getAdminProduct } from "../../actions/productAction";
// // import { getAllOrders } from "../../actions/orderAction.js";
// // import { getAllUsers } from "../../actions/userAction.js";

// const Dashboard = () => {
//   const dispatch = useDispatch();

//   const { products } = useSelector((state) => state.products);

//   // const { orders } = useSelector((state) => state.allOrders);

//   // const { users } = useSelector((state) => state.allUsers);

//   let outOfStock = 0;

//   products &&
//     products.forEach((item) => {
//       if (item.Stock === 0) {
//         outOfStock += 1;
//       }
//     });

//   useEffect(() => {
//     // dispatch(getAdminProduct());
//     // dispatch(getAllOrders());
//     // dispatch(getAllUsers());
//   }, [dispatch]);

//   // let totalAmount = 0;
//   // orders &&
//   //   orders.forEach((item) => {
//   //     totalAmount += item.totalPrice;
//   //   });

//   // const lineState =  {
//   //   labels: ["Initial Amount", "Amount Earned"],
//   //   datasets: [
//   //     {
//   //       label: "TOTAL AMOUNT",
//   //       backgroundColor: ["tomato"],
//   //       hoverBackgroundColor: ["rgb(197, 72, 49)"],
//   //       data: [0, 400],
//   //     },
//   //   ],
//   // };

//   // const doughnutState = {
//   //   labels: ["Out of Stock", "InStock"],
//   //   datasets: [
//   //     {
//   //       backgroundColor: ["#00A6B4", "#6800B4"],
//   //       hoverBackgroundColor: ["#4B5000", "#35014F"],
//   //       data: [10, 20],
//   //     },
//   //   ],
//   // };

//   return (
//     <div className="dashboard">
//       <Sidebar />

//       <div className="dashboardContainer">
//         <Typography component="h1">Dashboard</Typography>

//         <div className="dashboardSummary">
//           <div>
//             <p>
//               Total Amount <br /> ₹{"50000"}
//             </p>
//           </div>
//           <div className="dashboardSummaryBox2">
//             <Link to="/admin/products">
//               <p>Product</p>
//               <p>"products?.length"</p>
//             </Link>
//             <Link to="/admin/orders">
//               <p>Orders</p>
//               <p>55</p>
//             </Link>
//             <Link to="/admin/users">
//               <p>Users</p>
//               <p>455</p>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

import React from "react";
import Sidebar from "./Sidebar.js";
import HeroSection from "./HeroSection";
import CardsSection from "./CardsSection";
import GraphsSection from "./GraphsSection";
import RecentActivitySection from "./RecentActivitySection";
import "./dashboard.scss";
import PerDayGraph from "./PerDayGraph";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setNavbar } from "../../Redux/slices/appConfigSlice.js";

const Dashboard = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setNavbar(false));
  }, []);
  const data1 = [
    {
      month: "Jan",
      orders: 10,
      days: [
        { day: "2023-01-01", orders: 2 },
        { day: "2023-01-02", orders: 3 },
        { day: "2023-01-03", orders: 1 },
        { day: "2023-01-04", orders: 4 },
      ],
    },
    {
      month: "Feb",
      orders: 20,
      days: [
        { day: "2023-02-01", orders: 3 },
        { day: "2023-02-02", orders: 5 },
        { day: "2023-02-03", orders: 2 },
        { day: "2023-02-04", orders: 10 },
      ],
    },
    {
      month: "Mar",
      orders: 15,
      days: [
        { day: "2023-03-01", orders: 1 },
        { day: "2023-03-02", orders: 4 },
        { day: "2023-03-03", orders: 5 },
        { day: "2023-03-04", orders: 5 },
      ],
    },
  ];

  return (
    <div className="dashboard">
      <Sidebar />
      <HeroSection />
      <CardsSection />
      <GraphsSection />
      <RecentActivitySection />
      <div className="graphs3-section1">
        <h2>Per </h2> <h2>Day </h2> <h2>Orders</h2>
        <div className="perdaychart">
          <PerDayGraph data1={data1[0].days} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
